<template>
    <div v-bind:class="{dkswitch:true,on:internalValue,disabled:disabled}" v-on:click="toggle()">
        <div class="mover"></div>
    </div>
</template>

<script>
export default {
  name: 'dkswitch',
  props: ["value","disabled"],
  computed: {
      internalValue: {
          get: function () { return this.value; },
          set: function(v1) {
              this.$emit("input", v1);
              this.$emit("switchflip",{value:v1});
          }
      }
  },
  methods: {
      toggle: function () {
          this.internalValue = !this.internalValue;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dkswitch {
    background-color: #727272;
    width: 40px;
    height: 20px;
    border-radius: 10px;
    position: relative;
    transition:all 0.25s ease;
    cursor:pointer;
    //box-shadow: inset 0 1px 1px rgba(0,0,0,0.35), inset 0 -1px 1px rgba(255,255,255,0.5);
    & .mover {
        height: 16px;
        position: absolute;
        top: 2px;
        left: 2px;
        background-color: white;
        border-radius: 15px;
        transition:all 0.25s ease;
        right:22px;
        //box-shadow: inset 0 -1px 0px rgba(0,0,0,0.5), inset 0 1px 0px rgba(255,255,255,0.5);
    }
    &.disabled {
        background-color:grey!important;
        pointer-events: none;
        & .mover {
            opacity:0.5;
        }
    }
    &.on {
        background-color:#00a900;
        & .mover {
            left:22px;
            right:2px;
        }
    }
}
</style>
